import React from "react";
import Users from "../pages/users/Users";
import UserDetails from "../pages/users/UserDetails";
import EditUser from "../pages/users/EditUser";
import Forum from "../pages/forums/Forum";
import ForumDetails from "../pages/forums/ForumDetails";

export const userRoutes = [
  { path: "/users", element: <Users /> },
  { path: "/users/:userId", element: <UserDetails /> },
  { path: "/users/:userId/edit", element: <EditUser /> },

  { path: "/forums", element: <Forum /> },
  { path: "/forums/:forumId", element: <ForumDetails /> },
];
